export const getQueryParam = (name: String) => {
  const params = window.location.search;
  const parsedParam = params.match(new RegExp(`[?&]${name}=([^&#]*)`));
  return parsedParam && decodeURIComponent(parsedParam[1]);
};
